import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HandbookComponent } from './handbook.component';
// import { AgreementTemplateComponent } from './agreement-template.component';

const routes: Routes = [{ path: '', component:HandbookComponent,pathMatch: "full"}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HandBookRoutingModule { }
